import React from 'react';
import { InputProps } from 'reactstrap';
import { GenericInputContainer, InputStyled } from './GenericInput.styles';
import LabelBold from 'src/components/Input/GenericInput/LabelBold';

export interface InputType {
  className?: string;
  labelText?: string;
  inputProps?: InputProps;
  children?: React.ReactNode;
}

const GenericInput = ({ children, inputProps = {}, labelText }: InputType) => {
  return (
    <GenericInputContainer>
      {labelText ? (
        <LabelBold style={{ marginBottom: '8px' }} htmlFor={inputProps.name}>
          {labelText}
        </LabelBold>
      ) : null}
      <InputStyled {...inputProps} id={inputProps.name}>
        {children}
      </InputStyled>
    </GenericInputContainer>
  );
};

export default GenericInput;
